<template>
<header class="HeaderBand-MAIN hide-scrollbar">

    <div class="filter-band" v-if="['parenthesis'].includes(route)">
        <button :class="{ 'active-filter-band-btn': filterBtn == 'todos' }" @click="setFilterBtn('todos'), searchBarEvents('todos')">TODOS</button>
        <button :class="{ 'active-filter-band-btn': filterBtn == 'editorial' }" @click="setFilterBtn('editorial'), searchBarEvents('editorial')">EDITORIAL</button>
        <button :class="{ 'active-filter-band-btn': filterBtn == 'noticias' }" @click="setFilterBtn('noticias'), searchBarEvents('noticias')">NOTICIAS</button>
        <button :class="{ 'active-filter-band-btn': filterBtn == 'eventos' }" @click="setFilterBtn('eventos'), searchBarEvents('eventos')">EVENTOS</button>
    </div>

    <div class="header-icons-row" v-if="route == 'artists'">
        <img src="../assets/artists-list.png"
            :class="{ 'header-icon': true, 'view-mode': true, 'view-mode-active': viewMode == 'list' }"
            @click="setViewMode('list')" />
        <!--<img src="../assets/artists-carousel.png"
            :class="{ 'header-icon': true, 'view-mode': true, 'view-mode-active': viewMode == 'carousel' }"
            @click="setViewMode('carousel')" />-->
        <img src="../assets/artists-tiles.png"
            :class="{ 'header-icon': true, 'view-mode': true, 'view-mode-active': viewMode == 'tiles' }"
            @click="setViewMode('tiles')" />
    </div>

    <div class="header-search" role="search" v-if="route == 'search'">
        <input type="text" placeholder="Buscar..." @focus="searchBarEvents('focus')" @blur="searchBarEvents('blur')" @keyup.enter="searchBarEvents('start')" v-model="searchTerm" ref="searchbar"/>
        <img src="../assets/search.png" @click="searchBarEvents('start')"/>
    </div>

    <div class="header-icons-row">
        <img src="../assets/search.png" class="header-icon"
            :style="`filter: invert(${['artists'].includes(route) ? 1 : 0})`"
            v-if="['artists'].includes(route)"
            @click="$router.push({ name: 'search' })"
        />
        <img src="../assets/menu-outline.png" class="header-icon"
            :style="`filter: invert(${['parenthesis', 'artists', 'search'].includes(route) ? 1 : 0})`"
            v-if="['artists', 'parenthesis', 'search'].includes(route)"
            @click.stop="toggleSideMenu(true)"
        />
    </div>

</header>
</template>

<script>
export default {
    name: 'HeaderBand',
    inject: ['toggleSideMenu'],
    data(){
        return{
            route: this.$route.name,
            params: this.$route.params,
            filterBtn: 'todos',
            viewMode: '',
            searchTerm: ''
        }
    },
    methods: {
        setFilterBtn(btn){
            this.filterBtn = btn;
        },

        setViewMode(mode){
            this.viewMode = mode;
            this.$router.push({ name: 'artists', params: { display: mode } });
        },

        searchBarEvents(evt){
            this.$emit('search-bar-events', evt, this.searchTerm);
            if(evt == 'start') this.$refs.searchbar.blur();
        }
    },
    mounted(){
        if(this.route == "parenthesis") this.filterBtn = 'todos';
        if(this.route == "artists") {
            console.log("ruta artists")
            if(['list', 'carousel', 'tiles'].includes(this.params.display)){
                console.log("ruta includes", this.params.display)
                this.$nextTick(() => {
                    this.viewMode = this.params.display;
                });
            }else{
                console.log("ruta else")
                this.$nextTick(() => {
                    this.viewMode = 'list';
                });
            } 
        }
              
    },
}
</script>

<style scoped lang="stylus">
.HeaderBand-MAIN
    display: flex
    align-items: center
    justify-content: space-between
    z-index: 1
    height: 6vw
    padding-top: 4vw

/* filters */
.filter-band
    display: flex
    align-items: center
    padding-left: 3vw
    overflow-x: auto
    mask-image: linear-gradient(to left, transparent 0%, white 15%)
    -webkit-mask-image: linear-gradient(to left, transparent 0%, white 15%)

    >button
        margin-right: 3vw
        border-radius: 100vw
        color: white
        border: none
        background-color: black
        font-family: "DM Mono", monospace
        padding: 5px 18px
        white-space: nowrap

    .active-filter-band-btn
        background-color: #015AFF !important

/* all icons */
.header-icons-row
    display: flex
    align-items: center
    margin-left: 3vw

.header-icon
    max-width: 6vw
    max-height: 6vw
    margin-right: 3vw

/* view mode */
.view-mode
    filter: grayscale(1) brightness(2.6)

.view-mode-active
    filter: none !important

/* search */
.header-search
    background-color: #212121
    display: flex
    align-items: center
    border-radius: 5px
    width: 100%
    margin-left: 3vw
    padding: 1vw
    animation: set-search 0.5s ease-out 1 forwards

    input
        height: 100% !important
        width: 100%
        background-color: transparent
        border: none
        color: white
        font-family: "Archivo ExtraCondensed", sans-serif
        font-size: 5vw
        padding-left: 1ch

    img
        max-width: 5.5vw
        max-height: 5.5vw
        filter: invert(1)
        cursor: pointer

@keyframes set-search
    0%
        width: 10vw
        margin-left: auto
    
    60%
        margin-left: auto

    65%
        margin-left: 3vw

    100%
        width: 100%
        margin-left: 3vw
</style>